export default function autoSelect(e: Event) {
    setTimeout(() => {
        try {
            if ((e.target as HTMLElement).tagName !== 'INPUT') (e.target as HTMLElement).querySelector('input')!.setSelectionRange(0, 9999)
            else (e.target as HTMLInputElement).setSelectionRange(0, 9999)
        } catch (error) {
            if ((e.target as HTMLElement).tagName !== 'INPUT') (e.target as HTMLElement).querySelector('input')!.select()
            else (e.target as HTMLInputElement).select()
        }
       
    }, 17)
    
}